import React from 'react'
import {Modal, ModalBody} from 'reactstrap'
import strings from '../../../lang/strings'
import {observer} from 'mobx-react'
import ConfirmButton from '../button/confirm_button'
import moment from 'moment'
import {FORMAT} from '../../../config/const'

const PopupDaily = observer((props) => {
  const {show, toggle, image, link, title} = props

  const onNotShowToday = () => {
    let today = moment(this).format(FORMAT.DATE)
    localStorage.setItem('popup_daily', today)
    toggle()
  }

  return (
    <Modal isOpen={show} toggle={() => toggle()} className='modal-point-pay'>
      <ModalBody>
        <div className='modal-header-custom d-center position-relative'>
          <div className='fs-20 sm-fs-18 f-sb'>{strings.daily_special}</div>
          <div className='modal-close-btn d-center position-absolute' onClick={() => toggle()}>
            <img src={'/assets/image/close.png'} alt='' className='modal-close'/>
          </div>
        </div>
        <div className='modal-content-area fs-16 sm-fs-15 f-m p-0'>
          <div className='fs-16 sm-fs-14 f-m pv-30 sm-pv-20 ph-30 sm-ph-20' dangerouslySetInnerHTML={{ __html: strings.daily_popup_desc }}></div>
          <div className='pb-30 sm-pb-20 ph-30 sm-ph-20'>
            <ConfirmButton enabled={true} className={'bd-0 btn-point-pay fs-15 sm-fs-14 f-m d-center'} onClick={() => onNotShowToday()} text={strings.not_show_today} />
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
})

export default PopupDaily
